import { toNumber, formatTimezoneOffset } from '@freelancer/utils';
import type { TimezoneApi } from 'api-typings/common/common';
import type { Timezone } from './timezones.model';

export function transformTimezone(timezone: TimezoneApi): Timezone {
  /**
   * The db stores the timezone offset as a float, e.g. 9.0, -7.75.
   * Multiply by -60 to get the same format as new Date().getTimezoneOffset().
   */
  const transformedTimezone = timezone.offset ? timezone.offset * -60 : 0;

  // Make sure all fields are provided since TimezoneApi makes
  // the fields optional.
  return {
    id: timezone.id ?? 0,
    country: timezone.country ?? '',
    timezoneName: timezone.timezone ?? '',
    offset: formatTimezoneOffset(transformedTimezone),
  };
}

export function transformTimezoneApi(
  timezone: Timezone | Partial<Timezone>,
): TimezoneApi {
  return {
    ...timezone,
    timezone: timezone.timezoneName,
    offset: timezone.offset ? transformTimezoneGMT(timezone.offset) : undefined,
  };
}

/**
 * This function accepts Greenwich Mean Time (GMT) timezone
 * string and converts to timezone offset value.
 */
function transformTimezoneGMT(gmt: string): number {
  const [, sign, hours, minutes] = gmt.match(/([-|+])(\d{2})(\d{2})/) || [];
  const offset = toNumber(hours) + toNumber(minutes) / 60;
  return offset * (sign === '+' ? 1 : -1);
}
